/**
 * Generates a unique, strong password (≥16 chars)
 * Mixed case + digits + symbol; no ambiguous characters (0, O, I, l, 1).
 */
export function generateStrongPassword(length = 16): string {
  const uppers = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lowers = 'abcdefghijkmnopqrstuvwxyz';
  const digits = '23456789';
  const symbols = '!@#$%&*+=-_?';
  const all = uppers + lowers + digits + symbols;

  const getRandomChar = (pool: string) => {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return pool[array[0] % pool.length];
  };

  const chars = [
    getRandomChar(uppers),
    getRandomChar(uppers),
    getRandomChar(lowers),
    getRandomChar(lowers),
    getRandomChar(digits),
    getRandomChar(digits),
    getRandomChar(symbols),
    getRandomChar(symbols),
  ];

  while (chars.length < length) {
    chars.push(getRandomChar(all));
  }

  // Fisher-Yates shuffle
  for (let i = chars.length - 1; i > 0; i--) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    const j = array[0] % (i + 1);
    const temp = chars[i];
    chars[i] = chars[j];
    chars[j] = temp;
  }

  return chars.join('');
}
